import React, { useEffect, useState } from 'react';
import { dashboardService } from '@/services/dashboardService';
import StatsCard from './components/StatsCard';

const SimpleDashboard = () => {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        console.log('SimpleDashboard: Fetching stats');
        const response = await dashboardService.getStats();
        console.log('SimpleDashboard: Stats response', response);
        setStatsData(response.data);
      } catch (err) {
        console.error('SimpleDashboard: Error fetching stats', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Simple Dashboard Test</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatsCard
          title="Total Projects"
          value={statsData?.projects?.total?.toString() || '0'}
          change={statsData?.projects?.change || '0%'}
          changeType={statsData?.projects?.changeType || 'neutral'}
          icon="projects"
          loading={false}
        />
        <StatsCard
          title="Active Tasks"
          value={statsData?.tasks?.active?.toString() || '0'}
          change={statsData?.tasks?.change || '0%'}
          changeType={statsData?.tasks?.changeType || 'neutral'}
          icon="tasks"
          loading={false}
        />
        <StatsCard
          title="Team Members"
          value={statsData?.employees?.total?.toString() || '0'}
          change={statsData?.employees?.change || '0%'}
          changeType={statsData?.employees?.changeType || 'neutral'}
          icon="users"
          loading={false}
        />
        <StatsCard
          title="Revenue"
          value={statsData?.revenue?.total || '₦0'}
          change={statsData?.revenue?.change || '0%'}
          changeType={statsData?.revenue?.changeType || 'neutral'}
          icon="revenue"
          loading={false}
        />
      </div>
    </div>
  );
};

export default SimpleDashboard;